import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  SelectInput,
  PasswordInput,
  ArrayInput,
  SimpleFormIterator,
  CreateProps,
  ReferenceInput,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import RetypePasswordInput from "components/RetypePasswordInput";
import { Grid, Typography } from "@material-ui/core";
import { salutationList } from "./conts";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import {
  mobilePhoneNoValidation,
  postalCodeValidation,
} from "utils/validation";
import CustomAddressAutoCompleteInput from "./components/CustomAddressAutoCompleteInput";
import EmailInput from "../../components/EmailInput";
import CreateWrapper from "../../components/CreateWrapper";

const PersonInChargeCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Person In Charges", link: "/personInCharges" },
    { title: "Create", link: "/personInCharges/create" },
  ];

  const transform = async (data: any) => {
    data.status = "active";

    return data;
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Person In Charge"
        transform={transform}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Company Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="Name"
                source="companyId"
                reference="companies"
                disabled
              >
                <SelectInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Personal Details</Typography>
            </Grid>

            <Grid item xs={1}>
              <SelectInput source="salutation" choices={salutationList} />
            </Grid>
            <Grid item xs={11}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="First Name"
                source="firstName"
                validate={required()}
              />
            </Grid>
            <Grid item xs={4}>
              <TextInput
                label="Last Name"
                source="lastName"
                validate={required()}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <EmailInput label="Email" source="user.email" />
            </Grid>
            <Grid item xs={4}>
              <TextInput
                label="Mobile No."
                source="mobile"
                validate={mobilePhoneNoValidation}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <PasswordInput
                label="Password"
                source="user.password"
                validate={required()}
              />
            </Grid>
            <Grid item xs={4}>
              <RetypePasswordInput />
            </Grid>
            <Grid item xs={4}></Grid>

            {/* <Grid item xs={4}>
              <TextInput
                label="VA Number"
                source="vaNumber"
                validate={vaNumberValidation}
              />
            </Grid>
            <Grid item xs={8}></Grid> */}

            <Grid item xs={12}>
              <Typography variant="h6">Billing Info</Typography>
            </Grid>

            <Grid item xs={2}>
              <TextInput
                label="Billing Name"
                source="billingAddress.name"
                validate={required()}
              />
            </Grid>
            <Grid item xs={10}></Grid>

            <Grid item xs={4}>
              <CustomAddressAutoCompleteInput
                label="Postal Code"
                source="billingAddress.postalCode"
                referenceSource="locationData"
                validate={postalCodeValidation}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="billingAddress.unit" />
            </Grid>
            <Grid item xs={2}>
              <TextInput
                label="Block No."
                source="billingAddress.blockNumber"
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Building Name"
                source="billingAddress.building"
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Address"
                source="billingAddress.address"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Billing Emails</Typography>
            </Grid>

            <Grid item xs={7}>
              <ArrayInput source="billingEmails" validate={required()}>
                <SimpleFormIterator>
                  <EmailInput label="Email" source="email" />
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default PersonInChargeCreate;
